import { render, staticRenderFns } from "./AvgCheckReport.vue?vue&type=template&id=15b4eca0&scoped=true"
import script from "./AvgCheckReport.vue?vue&type=script&lang=ts"
export * from "./AvgCheckReport.vue?vue&type=script&lang=ts"
import style0 from "./AvgCheckReport.vue?vue&type=style&index=0&id=15b4eca0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4eca0",
  null
  
)

export default component.exports